import React from "react";
import DotsMenu from "../shared/DotsMenu";

const CoinsIcon = () => (
  <svg
    width="45"
    height="38"
    viewBox="0 0 45 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43 23.4195C40.9861 24.4266 37.5193 25.0918 33.5773 25.0918C29.6348 25.0918 26.1673 24.4266 24.1534 23.4195C22.99 22.8363 22.31 22.1399 22.31 21.3901V25.4482C22.31 27.4925 27.3538 29.1504 33.5773 29.1504C39.7997 29.1504 44.844 27.4925 44.844 25.4482V21.3901C44.844 22.1399 44.1641 22.8363 43 23.4195Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.5779 17.9399C27.3544 17.9399 22.31 19.5972 22.31 21.6416C22.31 22.3913 22.99 23.0878 24.154 23.6709C26.1679 24.6781 29.6354 25.3439 33.5779 25.3439C37.5193 25.3439 40.9867 24.6781 43.0006 23.6709C44.1647 23.0878 44.8446 22.3913 44.8446 21.6416C44.8446 19.5972 39.8003 17.9399 33.5779 17.9399Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.69 25.7193C18.6761 26.7264 15.2093 27.3916 11.2673 27.3916C7.32479 27.3916 3.85731 26.7264 1.84344 25.7193C0.679956 25.1362 0 24.4397 0 23.6899V27.748C0 29.7923 5.04376 31.4503 11.2673 31.4503C17.4897 31.4503 22.534 29.7923 22.534 27.748V23.6899C22.534 24.4397 21.8541 25.1362 20.69 25.7193Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2679 20.2402C5.04437 20.2402 0 21.8975 0 23.9419C0 24.6916 0.679956 25.3881 1.84404 25.9712C3.85792 26.9784 7.32539 27.6442 11.2679 27.6442C15.2093 27.6442 18.6767 26.9784 20.6906 25.9712C21.8547 25.3881 22.5346 24.6916 22.5346 23.9419C22.5346 21.8975 17.4903 20.2402 11.2679 20.2402Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.19 32.1592C30.1761 33.1664 26.7093 33.8315 22.7673 33.8315C18.8248 33.8315 15.3573 33.1664 13.3434 32.1592C12.18 31.5761 11.5 30.8796 11.5 30.1299V34.1879C11.5 36.2323 16.5438 37.8902 22.7673 37.8902C28.9897 37.8902 34.034 36.2323 34.034 34.1879V30.1299C34.034 30.8796 33.3541 31.5761 32.19 32.1592Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7679 26.6802C16.5444 26.6802 11.5 28.3375 11.5 30.3818C11.5 31.1316 12.18 31.828 13.344 32.4112C15.3579 33.4183 18.8254 34.0841 22.7679 34.0841C26.7093 34.0841 30.1767 33.4183 32.1906 32.4112C33.3547 31.828 34.0346 31.1316 34.0346 30.3818C34.0346 28.3375 28.9903 26.6802 22.7679 26.6802Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43 17.4395C40.9861 18.4466 37.5192 19.1118 33.5773 19.1118C29.6348 19.1118 26.1673 18.4466 24.1534 17.4395C22.9899 16.8564 22.31 16.1599 22.31 15.4102V19.4682C22.31 21.5126 27.3537 23.1705 33.5773 23.1705C39.7997 23.1705 44.844 21.5126 44.844 19.4682V15.4102C44.844 16.1599 44.1641 16.8564 43 17.4395Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.5779 11.96C27.3543 11.96 22.31 13.6172 22.31 15.6616C22.31 16.4113 22.9899 17.1078 24.154 17.6909C26.1679 18.6981 29.6354 19.3639 33.5779 19.3639C37.5192 19.3639 40.9867 18.6981 43.0006 17.6909C44.1647 17.1078 44.8446 16.4113 44.8446 15.6616C44.8446 13.6172 39.8003 11.96 33.5779 11.96Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.69 19.4687C18.6761 20.4557 15.2093 21.1076 11.2673 21.1076C7.32479 21.1076 3.85731 20.4557 1.84344 19.4687C0.679956 18.8973 0 18.2147 0 17.48V21.4569C0 23.4603 5.04376 25.0851 11.2673 25.0851C17.4897 25.0851 22.534 23.4603 22.534 21.4569V17.48C22.534 18.2147 21.8541 18.8973 20.69 19.4687Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2679 14.2598C5.04437 14.2598 0 15.8839 0 17.8874C0 18.6221 0.679956 19.3047 1.84404 19.8761C3.85792 20.8631 7.32539 21.5156 11.2679 21.5156C15.2093 21.5156 18.6767 20.8631 20.6906 19.8761C21.8547 19.3047 22.5346 18.6221 22.5346 17.8874C22.5346 15.8839 17.4903 14.2598 11.2679 14.2598Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32.19 26.1792C30.1761 27.1864 26.7093 27.8516 22.7673 27.8516C18.8248 27.8516 15.3573 27.1864 13.3434 26.1792C12.18 25.5961 11.5 24.8996 11.5 24.1499V28.2079C11.5 30.2523 16.5438 31.9102 22.7673 31.9102C28.9897 31.9102 34.034 30.2523 34.034 28.2079V24.1499C34.034 24.8996 33.3541 25.5961 32.19 26.1792Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7679 20.7002C16.5444 20.7002 11.5 22.3575 11.5 24.4018C11.5 25.1516 12.18 25.8481 13.344 26.4312C15.3579 27.4383 18.8254 28.1041 22.7679 28.1041C26.7093 28.1041 30.1767 27.4383 32.1906 26.4312C33.3547 25.8481 34.0346 25.1516 34.0346 24.4018C34.0346 22.3575 28.9903 20.7002 22.7679 20.7002Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43 11.4595C40.9861 12.4667 37.5193 13.1318 33.5773 13.1318C29.6348 13.1318 26.1673 12.4667 24.1534 11.4595C22.99 10.8764 22.31 10.1799 22.31 9.43018V13.4882C22.31 15.5326 27.3538 17.1905 33.5773 17.1905C39.7997 17.1905 44.844 15.5326 44.844 13.4882V9.43018C44.844 10.1799 44.1641 10.8764 43 11.4595Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.5779 5.97998C27.3543 5.97998 22.31 7.63727 22.31 9.68163C22.31 10.4314 22.9899 11.1278 24.154 11.711C26.1679 12.7181 29.6354 13.3839 33.5779 13.3839C37.5192 13.3839 40.9867 12.7181 43.0006 11.711C44.1647 11.1278 44.8446 10.4314 44.8446 9.68163C44.8446 7.63727 39.8003 5.97998 33.5779 5.97998Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.69 13.9893C18.6761 14.9964 15.2093 15.6616 11.2673 15.6616C7.32479 15.6616 3.85731 14.9964 1.84344 13.9893C0.679956 13.4062 0 12.7097 0 11.96V16.018C0 18.0624 5.04376 19.7203 11.2673 19.7203C17.4897 19.7203 22.534 18.0624 22.534 16.018V11.96C22.534 12.7097 21.8541 13.4062 20.69 13.9893Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2679 8.50977C5.04437 8.50977 0 10.1671 0 12.2114C0 12.9611 0.679956 13.6576 1.84404 14.2407C3.85792 15.2479 7.32539 15.9137 11.2679 15.9137C15.2093 15.9137 18.6767 15.2479 20.6906 14.2407C21.8547 13.6576 22.5346 12.9611 22.5346 12.2114C22.5346 10.1671 17.4903 8.50977 11.2679 8.50977Z"
      fill="#7F56D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M43 5.47953C40.9861 6.48668 37.5193 7.15184 33.5773 7.15184C29.6348 7.15184 26.1673 6.48668 24.1534 5.47953C22.99 4.89641 22.31 4.19992 22.31 3.4502V7.50823C22.31 9.55259 27.3538 11.2105 33.5773 11.2105C39.7997 11.2105 44.844 9.55259 44.844 7.50823V3.4502C44.844 4.19992 44.1641 4.89641 43 5.47953Z"
      fill="#D6BBFB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.5779 0C27.3544 0 22.31 1.65729 22.31 3.70165C22.31 4.45137 22.99 5.14786 24.154 5.73098C26.1679 6.73813 29.6354 7.40392 33.5779 7.40392C37.5193 7.40392 40.9867 6.73813 43.0006 5.73098C44.1647 5.14786 44.8446 4.45137 44.8446 3.70165C44.8446 1.65729 39.8003 0 33.5779 0Z"
      fill="#7F56D9"
    />
  </svg>
);

/**
 * Single analytics metric card displaying a headline value with an icon.
 *
 * @param {string}    label         Card heading  e.g. "Media Spend"
 * @param {string}    sub           Subtitle      e.g. "Total marketing spend"
 * @param {string}    metric        Metric label  e.g. "Cost"
 * @param {string}    value         Formatted value e.g. "$56,692"
 * @param {ReactNode} [icon]        Custom icon node; defaults to the stacked coins SVG
 * @param {Function}  [onMenuClick] Called when the 3-dot menu is clicked
 */
const MetricCard = ({ label, sub, metric, value, icon, onMenuClick }) => (
  <div
    className="rounded-4 p-4 h-100"
    style={{
      background: "#fff",
      border: "1px solid #F2F4F7",
      boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
    }}
  >
    <div className="d-flex justify-content-between align-items-start mb-2">
      <div>
        <div
          className="fw-semibold text-[18px]"
          style={{ color: "#101828", fontSize: "1.25rem" }}
        >
          {label}
        </div>
        <div style={{ fontSize: "1rem", color: "#98A2B3", marginTop: 2 }}>
          {sub}
        </div>
      </div>
      {/* <button
        className="btn p-0"
        style={{ background: "transparent", border: "none" }}
        onClick={onMenuClick}
        aria-label="More options"
      >
        <DotsMenu />
      </button> */}
    </div>

    <div className="d-flex align-items-center gap-4 border-top border-gray-200 pt-4 mt-4">
      {icon ?? <CoinsIcon />}
      <div>
        <div style={{ fontSize: "0.90rem", color: "#667085" }}>{metric}</div>
        <div
          className="fw-bold"
          style={{ fontSize: "1.5rem", color: "#101828", lineHeight: 1.2 }}
        >
          {value}
        </div>
      </div>
    </div>
  </div>
);

export default MetricCard;
